// extracted by mini-css-extract-plugin
module.exports = {"singleProperty":"ToggleSelector_singleProperty__2el8w","switch":"ToggleSelector_switch__mcTSq"};